<template>
  <div
    class="link-button"
    @click="$emit('click')"
  >
    <i
      v-if="icon !== ''"
      :class="[`icon-${icon}`]"
      :style="{color: color, fontSize: `${iconSize}px`,}"
      class="link-icon"
    />
    <span
      :style="{color: color}"
      :class="[labelClasses]"
    >{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'LinkButton',
  props: {
    disabled: { type: Boolean, default: false },
    icon: { type: String, default: '' },
    iconSize: { type: Number, default: 16 },
    color: { type: String, default: '' },
    label: { type: String, required: true },
    labelClasses: { type: String, default: '' },
  },
  emits: ['click'],
};
</script>

<style lang="scss">

.link-button {
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  .link-icon {
    font-size: 18px;
    margin-right: 5px;
  }
}

</style>
